"use client";

import { useCallback } from "react";
import { trackAudioPlay } from "@/lib/gtag";

export default function AudioButton({ src, word }: { src: string; word: string }) {
  const play = useCallback(() => {
    trackAudioPlay(word);
    const audio = new Audio(src);
    audio.play();
  }, [src, word]);

  return (
    <button
      onClick={play}
      aria-label={`播放 ${word} 的發音`}
      className="inline-flex items-center gap-1 rounded-full bg-amber-100 px-3 py-1.5 text-sm font-medium text-amber-700 transition hover:bg-amber-200"
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="h-4 w-4">
        <path d="M11.26 3.691A1.2 1.2 0 0 1 12 4.8v14.4a1.199 1.199 0 0 1-2.048.848L5.503 15.6H2.4a1.2 1.2 0 0 1-1.2-1.2V9.6a1.2 1.2 0 0 1 1.2-1.2h3.103l4.449-4.448a1.2 1.2 0 0 1 1.308-.261Z" />
        <path d="M15.53 7.47a.75.75 0 0 1 1.06 0 8.25 8.25 0 0 1 0 11.06.75.75 0 1 1-1.06-1.06 6.75 6.75 0 0 0 0-9.94.75.75 0 0 1 0-1.06Z" />
        <path d="M17.65 5.35a.75.75 0 0 1 1.06 0c4.386 4.386 4.386 11.504 0 15.89a.75.75 0 0 1-1.06-1.06 9.75 9.75 0 0 0 0-13.77.75.75 0 0 1 0-1.06Z" />
      </svg>
      發音
    </button>
  );
}
